import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItemAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { CodigoTurnoEntrega } from "app/types/CodigoTurnoEntrega"
import { WindowMU } from "app/types/WindowMU"


import globalMU from "globalMU"

declare var window: WindowMU

export type AlterarTurnoEntregaItemParams = {
    identificadorItem: number,
    turnoEntrega: CodigoTurnoEntrega,
    itemOrcamentoLegado?: any
}

export async function alterarTurnoEntregaItem(input: AlterarTurnoEntregaItemParams) {

    try {
        globalMU.blockUI({ tryPassiveLoading: true })

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirTurnoEntregaItem(
            store.getState().orcamento.IdentificadorOrcamento,
            input.identificadorItem,
            input.turnoEntrega) 

        const atualizarOrcamento = () => {
            const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == input.identificadorItem);
            store.dispatch(atualizarItemAction({ identificador: input.identificadorItem, dados: itemAtualizado }))
        }


        if (!("HasErrors" in orcamentoAtualizado)) {
            atualizarOrcamento() 
        }
        
    } finally {
        globalMU.unblockUI()
    }


}